import type { FunctionComponent } from 'react';
import { GovernmentOverlaysBrickInformationModalContent } from './subcomponents/GovernmentOverlaysBrickInformationModalContent';
import { DialogModal } from '../../../../../app-kit/components/DialogModal/DialogModal';

interface GovernmentOverlaysBrickInformationModalProps {
  opened: boolean;
  onClose: () => void;
}

export const GovernmentOverlaysBrickInformationModal: FunctionComponent<
  GovernmentOverlaysBrickInformationModalProps
> = ({ opened, onClose }) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="What are planning overlays?"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      gap="0"
    >
      <GovernmentOverlaysBrickInformationModalContent />
    </DialogModal>
  );
};
